import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'filters'
})
export class FiltersPipe implements PipeTransform {
	transform(items: any[], filters: any, andFilter: boolean = false): any[] {

		if(!Object.keys(filters).length)
			return items;

		if(!items?.length)
			return [];

		filters = Object.entries(filters).map(([field, filter]: [string, any]) => {

			switch(typeof filter) {
				case 'boolean':
				case 'number':
					return item => item.hasOwnProperty(field) ? filter === item[field] : true;

				case 'object':
					if(Array.isArray(filter))
						return item => filter.map(f => item[field] === f).reduce((acc, current) => acc || current, false);

				default:
					return item => {
						let searcher = new RegExp(filter, 'gi');
						return item[field] ? 
								searcher.test(item[field].normalize('NFKD')) || searcher.test(item[field]) :
								true;
					}
			}
		});

		return items.filter(item =>
			Object.values(filters)
				  .map((filterFn: Function) => filterFn(item))
				  .reduce((acc, current) => (andFilter ? (acc && current) : (acc || current)), andFilter)
		);
	}
}
